import './useLoadableRoutesConfig';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import AtomProgress from '../../components/atoms/AtomProgress';
import { styleConfigs } from '../../components/resources/styleConfigs';
import BoxWrapper from '../../components/wrappers/BoxWrapper';

interface ILoadableRoutes {
  children: any;
}

const LoadableRoutes = (props: ILoadableRoutes): JSX.Element => {
  const { children } = props;
  const { t } = useTranslation('useLoadableRoutes');
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={
        pathname.includes('wizard') ? (
          <BoxWrapper />
        ) : (
          <BoxWrapper sx={{ position: 'relative', height: styleConfigs.dimensions.height100vh }}>
            <AtomProgress
              visible
              layout="overlay"
              background="grey"
              loadingText={t('LOADER_TEXT')}
              textColor="prussianBlue"
            />
          </BoxWrapper>
        )
      }
    >
      {children}
    </Suspense>
  );
};

export default LoadableRoutes;
